import React, { FC } from 'react';
import { createFragmentContainer, graphql, RelayProp } from 'react-relay';
import { FormattedMessage } from 'react-intl';

import { PdpSharedDetail } from './PdpSharedDetail';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';
import { Link } from 'dibs-elements/exports/Link';

import { PdpSharedDetailFramingOptions_item as Item } from './__generated__/PdpSharedDetailFramingOptions_item.graphql';
import { PdpSharedDetailFramingOptions_user as User } from './__generated__/PdpSharedDetailFramingOptions_user.graphql';

type Props = {
    detailValues: string[];
    delimiter: string;
    currency: string;
    relay: RelayProp;
    itemId: string;
    item: Item;
    user: User;
};

const PdpSharedDetailFramingOptionsComponent: FC<Props> = props => {
    const { detailValues, currency, delimiter, item, user } = props;
    const trackingLabel = 'framing options';

    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                currency={currency}
                delimiter={delimiter}
                selectedSkuId={null}
            />
            <SharedContactDealerWrapper
                item={item}
                launchOrigin={trackingLabel}
                user={user}
                currency={currency}
            >
                {(onClick: () => void) => (
                    <Link onClick={onClick} dataTn="item-details-framing-options-contact-gallery">
                        <FormattedMessage
                            id="abf.pdp.framingOptionsContactGalleer"
                            defaultMessage="Contact Gallery"
                        />
                    </Link>
                )}
            </SharedContactDealerWrapper>
        </>
    );
};

export const PdpSharedDetailFramingOptions = createFragmentContainer(
    PdpSharedDetailFramingOptionsComponent,
    {
        item: graphql`
            fragment PdpSharedDetailFramingOptions_item on Item {
                ...SharedContactDealerWrapper_item
            }
        `,
        user: graphql`
            fragment PdpSharedDetailFramingOptions_user on User {
                ...SharedContactDealerWrapper_user
                serviceId
            }
        `,
    }
);
